<template>
  <v-row 
    v-if="!editedItem"
  >
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-btn
        block
        @click="onAdd"
      >
        A�adir
      </v-btn>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col
      cols="12"
      sm="12"
    >
      <v-text-field
        v-bind="{ 'outlined' : true}"
        v-model="editedItem.Name"
        :label="$t('sysUser.name', locale)"
        hide-details
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      style="padding: 10px 25px 30px 25px;"
    >
      <small style="color: gray;">
        Imagen:
      </small>
      <br/>
      <br/>
      <select-image 
        :image="editedItem.tmpImage"
        :onChange="handleChangeImage"
        :locale="locale"
        :folder="editedItem.WorkspaceID"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      style="padding: 0 25px;"
    >
      <small style="color: gray;">
        Mensaje:
      </small>
      <br/>
      <translate
        v-model="editedItem.Message"
        :languages="languages"
        label="Mensaje"
        @input="handleChange"
        type="richText"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      style="padding: 15px 15px 0 15px;"
    >
      <small style="color: gray;">
        Icono:
      </small>
      <br/>
      <v-btn-toggle
        v-model="editedItem.Icon" 
        hide-details
      >
        <v-btn :value="'mdi-information'" @click="editedItem.Icon = 'mdi-information'" text>
          <v-icon>mdi-information</v-icon>
        </v-btn>
        <v-btn :value="'mdi-alert'" @click="editedItem.Icon = 'mdi-alert'" text>
          <v-icon>mdi-alert</v-icon>
        </v-btn>
        <v-btn :value="'mdi-help-circle'" @click="editedItem.Icon = 'mdi-help-circle'" text>
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
        <v-btn :value="'mdi-check-circle'" @click="editedItem.Icon = 'mdi-check-circle'" text>
          <v-icon>mdi-check-circle</v-icon>
        </v-btn>
        <v-btn :value="'mdi-email'" @click="editedItem.Icon = 'mdi-email'" text>
          <v-icon>mdi-email</v-icon>
        </v-btn>
        <v-btn :value="'mdi-clock'" @click="editedItem.Icon = 'mdi-clock'" text>
          <v-icon>mdi-clock</v-icon>
        </v-btn>
        <v-btn :value="''" @click="editedItem.Icon = ''" text>
          <v-icon style="opacity: 0.2">mdi-cancel</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <v-checkbox
        v-model="editedItem.Remember"
        label="Solo mostrar una vez"
        hide-details
        dense
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <v-card
        color="#CCCCCC"
        style="padding: 20px;"
      >
        <v-checkbox
          v-model="editedItem.WithButton"
          label="Con bot�n"
          dense
        />
        <translate
          v-show="editedItem.WithButton"
          v-model="editedItem.ButtonText"
          :languages="languages"
          label="Texto"
          @input="handleChange"
        />
        <translate
          v-show="editedItem.WithButton"
          v-model="editedItem.ButtonLink"
          :languages="languages"
          label="Enlace"
          @input="handleChange"
        />
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <v-checkbox
        v-model="editedItem.Hide"
        label="Oculto"
        hide-details
        dense
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <small style="color: gray;margin-bottom: 20px;">
        Colores:
      </small>
      <color-picker-primary-secondary
        style="width: 100px;"
        :primaryColor="editedItem.BGColor"
        :secondaryColor="editedItem.Color"
        :onChangeColor="handleChangeColors"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <v-card
        color="#CCCCCC"
        style="padding: 20px;"
      >
        <availability
          v-model="editedItem.Availability"
          @change="handleChangeAvailability"
          :locale="locale"
          :inPanel="true"
        />
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
      <action-buttons
        :id="editedItem.ID"
        :onDeleteItem="handleDelete"
        :onSaveItem="handleSave"
        :onClose="onClose"
        :locale="locale"
      />
    </v-col>
  </v-row>
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
import ColorPickerPrimarySecondary from '@/components/ColorPickerPrimarySecondary'
import ActionButtons from '@/components/ActionButtons'
import Availability from '@/components/Availability'
import Translate from '@/components/Translate'
import SelectImage from '@/components/selectImage/Index'
export default {
  components: {
    ColorPickerPrimarySecondary,
    ActionButtons,
    Availability,
    Translate,
    SelectImage,
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    onAdd: {
      type: Function,
      requried: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async handleSave () {
      try {
        this.loading = true
        if (this.editedItem.Availability) {
          this.editedItem.Availability.IsTemp = true
        } else {
          this.editedItem.Availability = { IsTemp: false }
        }
        if (!this.editedItem.ID) {
          apiDtouch.addItem(`v1/private/pop-up/`, this.editedItem)
            .then(() => {
              this.loading = false
              this.onClose(true)
            })
            .catch(error => {
              console.log(error)
              alert('error')
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          apiDtouch.updateItem(`v1/private/pop-up/${this.editedItem.ID}`, this.editedItem)
            .then(() => {
              this.loading = false
              this.onClose(true)
            })
            .catch(error => {
              console.log(error)
              alert('error')
            })
            .finally(() => {
              this.loading = false
            })
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleDelete () {
      if (!this.editedItem.ID) {
        alert('ERROR')
        return
      }
      this.loading = false
      apiDtouch.deleteItem(`v1/private/pop-up/${this.editedItem.ID}`)
        .then(() => {
          this.loading = false
          this.onClose(true)
        })
        .catch(error => {
          console.log(error)
          alert('error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleChangeImage (v) {
      if (!v) return 
      console.log(v)
      this.editedItem.tmpImage = v.base64
      this.editedItem.newImage = v
      this.handleChange()
    },
    handleChangeColors (bg, color) {
      this.editedItem.BGColor = bg ? bg : 'white'
      this.editedItem.Color = color ? color : 'black'
      this.handleChange()
    },
    handleChangeAvailability (v) {
      this.editedItem.Availability = v
    },
    handleChange () {
    },
  },
}
</script>
